<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="space-y-32">
    <div class="space-y-24">
      <header class="space-y-8">
        <div class="flex items-center gap-8">
          <RevIllustration
            alt=""
            :height="30"
            src="/img/partnerships/phone.svg"
            :width="16"
          />
          <div aria-hidden="true">+</div>
          <RevIllustration
            v-if="offers[0].partner.logo"
            alt=""
            :height="30"
            :src="offers[0].partner.logo.url"
            :width="30"
          />
        </div>

        <h2 class="heading-1 whitespace-pre-line">
          <FormattedMessage
            :definition="translations.title"
            :values="{ partner: partner.label }"
          >
            <template #price>
              <span class="text-static-brand-hi">
                {{ i18n.price(highestSubsidyOffer.subsidy) }}
              </span>
              <template
                v-if="
                  highestSubsidyOffer.baseOffer &&
                  hasSubsidyBoost(highestSubsidyOffer)
                "
              >
                 <span class="line-through">
                  {{ i18n.price(highestSubsidyOffer.baseOffer.subsidy) }}
                </span>
              </template>
            </template>
          </FormattedMessage>
          <template v-if="partner.discountConditions">*</template>
        </h2>
      </header>

      <div class="space-y-24">
        <OfferCard v-for="offer in offers" :key="offer.id" :offer />
      </div>
    </div>

    <RevInfoBlock
      :content="
        i18n(translations.keepYourPhoneNumberContent, {
          partner: partner.label,
        })
      "
      :icon="IconContact"
      :title="i18n(translations.keepYourPhoneNumberTitle)"
      variant="default"
    />

    <p v-if="partner.discountConditions" class="body-2">
      *{{ partner.discountConditions }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { MobilePlanOfferWithPerks } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconContact } from '@ds/icons/IconContact'

import translations from './MobilePlanOffers.translations'
import OfferCard from './components/OfferCard/OfferCard.vue'

const i18n = useI18n()

const props = defineProps<{
  offers: MobilePlanOfferWithPerks[]
}>()

function getHighestSubsidyOffer(offers: readonly MobilePlanOfferWithPerks[]) {
  return offers.reduce<MobilePlanOfferWithPerks>(
    (highestSubsidyOffer, offer) => {
      const highestAmount = parseInt(highestSubsidyOffer.subsidy.amount, 10)
      const amount = parseInt(offer.subsidy.amount, 10)

      if (amount > highestAmount) return offer

      return highestSubsidyOffer
    },
    offers[0],
  )
}

function hasSubsidyBoost(offer: MobilePlanOfferWithPerks) {
  return offer.baseOffer
    ? parseInt(offer.subsidy.amount, 10) >
        parseInt(offer.baseOffer.subsidy.amount, 10)
    : false
}

const highestSubsidyOffer = computed(() => {
  return getHighestSubsidyOffer(props.offers)
})

const partner = computed(() => props.offers[0].partner)
</script>
